<script setup>
import EntityHistoryView from "@/shared/ui/history/EntityHistoryView.vue";

defineProps({
  form: {
    type: Object,
    default: () => null,
  },
});
</script>

<template>
  <EntityHistoryView entity-type="transaction" :entity-id="form?.id" />
</template>
